import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.788 4.204 9.81 2.226C8.461.873 7.785.197 7.06.357c-.726.16-1.055 1.058-1.713 2.854l-.445 1.215c-.175.479-.263.718-.42.903-.072.083-.152.158-.24.221-.198.142-.444.21-.935.346-1.107.305-1.66.457-1.869.82-.09.156-.137.334-.136.514.003.418.409.825 1.22 1.637l.944.945L.48 12.798a.51.51 0 0 0 .72.72l2.983-2.987.978.979c.817.818 1.225 1.226 1.646 1.227.177 0 .351-.046.505-.134.365-.208.519-.766.825-1.88.135-.49.203-.736.344-.933.062-.087.134-.165.215-.235.183-.159.42-.248.897-.427l1.229-.462c1.776-.667 2.664-1 2.82-1.724.157-.724-.514-1.395-1.855-2.738Z",
  fill: "#D1D1D1"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };